export class MemberNewsRequest {
    articleTitle: string;
    articleContent: string;
    postingAs: string;
    mainImageId: string;
    attachmentIds: string[];

    constructor(title: string,
        content: string,
        postingAs: string,
        mainImageId: string,
        attachmentIds: string[]
    ) {
        this.articleTitle = title;
        this.articleContent = content;
        this.postingAs = postingAs;
        this.mainImageId = mainImageId;
        this.attachmentIds = attachmentIds;
    }
}